import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {formatDate, parseDate} from 'common/util/date';

import template from './index.jade';

export class DateInput extends Component {
  static get observedAttributes() {
    return Component.observedAttributes.concat([`error`, `value`]);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(...arguments);
    if (name === `value`) {
      this.update({dateObj: parseDate(newValue)});
    }
  }

  get config() {
    return {
      template,
      defaultState: {
        dateObj: null,
      },
      helpers: {
        formatDate,
        focusedInput: () => this.emitFocus(),
        blurredInput: () => {
          this.inputEl.value = ``;
          this.emitBlur();
        },
        changedInput: (ev) => {
          ev.stopPropagation();
          const dateObj = this.inputEl.value.length ? parseDate(this.inputEl.value) : null;
          this.update({dateObj});
          this.emitChange();
        },
      },
    };
  }

  emitFocus() {
    this.dispatchEvent(new CustomEvent(`focus`));
  }

  emitBlur() {
    this.dispatchEvent(new CustomEvent(`blur`));
  }

  emitChange() {
    const detail = formatDate(this.state.dateObj, {iso: true});
    this.dispatchEvent(new CustomEvent(`change`, {detail}));
  }

  focus() {
    this.inputEl.focus();
  }

  select() {
    this.inputEl.select();
  }

  get inputEl() {
    return this.querySelector(`input`);
  }
}

export const DateInputEl = defineAndMakeJsxFactory(`mp-date-input`, DateInput);
